import dayjs from 'dayjs'
import React from 'react'

import { calendario } from '../../../utils/alternanciaIcones'

import 'dayjs/locale/pt-br'
import * as S from './styles'
import { GlobalStyles } from './styles'

/**
 * @typedef {Object} DatePickerProps
 *
 * @property {string | React.ReactNode} [prefixo]
 * @property {'default' | 'multiple' | 'range'} [type]
 * @property {string} [placeholder]
 * @property {string | React.ReactNode} [label]
 * @property {(value: Date | null) => void} onChange
 * @property {Date | Date[] | null} [value]
 * @property {Date | Date[] | null} [defaultValue]
 * @property {Date} [minDate]
 * @property {Date} [maxDate]
 * @property {boolean} [withinPortal]
 * @property {string} [name]
 * @property {boolean | string | React.ReactNode} [error]
 * @property {number} [fontSize]
 */

const customWeekDays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

/**
 * @param {DatePickerProps} props
 */
export default function DatePicker({
  prefixo,
  type = 'default',
  placeholder,
  label,
  onChange,
  value = undefined,
  defaultValue = undefined,
  minDate,
  maxDate,
  withinPortal = true,
  name,
  error,
  fontSize = 20
}) {
  const weekdayFormat = (date) => {
    const dayOfWeek = date.getDay()
    return customWeekDays[dayOfWeek]
  }

  const auxValue = minDate && dayjs(value).isBefore(minDate) ? minDate : value

  return (
    <>
      <GlobalStyles type={type} />
      <S.DatePickerInput
        fontSize={`${fontSize}px`}
        name={name} 
        error={error}
        $hasPrefixo={!!prefixo}
        minDate={minDate}
        maxDate={maxDate}
        type={type}
        allowSingleDateInRange
        popoverProps={{
          withinPortal: withinPortal,
          zIndex: 99999
        }}
        icon={<S.Prefixo>{prefixo}</S.Prefixo>}
        firstDayOfWeek={0}
        valueFormat="DD/MM/YYYY"
        zIndex={99999}
        locale="pt-BR"
        rightSection={<S.Img src={calendario()} />}
        placeholder={placeholder}
        label={label}
        radius="xl"
        value={auxValue}
        defaultValue={defaultValue}
        onChange={onChange}
        weekdayFormat={weekdayFormat}
      />
    </>
  )
}
